import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import useSWRImmutable from 'swr/immutable';
import Spinner from '/@/components/spinner';
import settings from '/@/core/settings';
import { axFetch, setPreferences } from '/@/store/session/actions';
import { getAppInstance, getUser } from '/@/store/session/selectors';
import { reverse } from '/@/utils/router';
import ErrorView from '/@/views/error-view';
import ErrorDialog from './error-dialog';
import styles from './styles.module.css';

const LibraryDetail = ({ slug }) => {
    const dispatch = useDispatch();
    const history = useNavigate();

    const [error, setError] = useState(false);
    const [country, setCountry] = useState(null);
    const appInstance = useSelector(getAppInstance);
    const user = useSelector(getUser);

    const libraryItemQuery = useSWRImmutable(
        `${settings.urls.apiDomain}/core/v1/library/items/${slug}/`,
        async (path) => {
            const apiUrl = new URL(path, window.location.origin);
            return await axFetch.get(apiUrl.toString());
        }
    );
    const libraryItem = libraryItemQuery.data?.data;

    const handleDialogAccept = bindActionCreators(setPreferences, dispatch);

    useEffect(() => {
        if (!libraryItem) return;
        if (!libraryItem.appInstances.includes(appInstance.id)) {
            const targetCountry = settings.app.instances.find((appInstance) =>
                libraryItem.appInstances.includes(appInstance.id)
            );

            if (targetCountry) {
                setError('country');
                setCountry(targetCountry.country);
            }
            return;
        }

        setError(false);
        setCountry(undefined);
    }, [appInstance, libraryItem]);

    const handleReset = () => history(reverse('NewHome'));

    function renderError() {
        if (error === 'country') {
            return (
                <ErrorDialog
                    visible
                    onAccept={() => handleDialogAccept({ country })}
                    onCancel={handleReset}
                    onClose={handleReset}
                />
            );
        }

        return <ErrorView />;
    }

    if (error) return renderError();

    if (libraryItemQuery.isValidating)
        return (
            <Stack justifyContent='center' alignItems='center' sx={{ height: '100%' }}>
                <Spinner />
            </Stack>
        );

    return (
        <div className={styles.root}>
            {libraryItem && (
                <iframe
                    src={`${libraryItem.file}?user=${user.username}`}
                    allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                />
            )}
        </div>
    );
};

export default LibraryDetail;
